
import '../../assets/css/mobilestyle.css'; 

function MobileHeader() {
  return (
    <>

 <input type="checkbox" id="menu-checkbox"/>
	
  <label className="menu-toggle" for="menu-checkbox">
    <span></span>
    <span></span>
    <span></span>
  </label>


  <nav className="side-menu">
    <ul>
      <li><a href="#">Home</a></li>
      <li>
       
        <input type="checkbox" id="drop1"/>
        <label for="drop1">Products <i class="bi bi-plus"></i></label>
        <ul className="submenu">
          <li><a href="#">Product A</a></li>
          <li><a href="#">Product B</a></li>
          <li>
          
            <input type="checkbox" id="subdrop1"/>
            <label for="subdrop1">More Products <i class="bi bi-plus"></i> </label>
            <ul className="submenu">
              <li><a href="#">Sub Product 1</a></li>
              <li><a href="#">Sub Product 2</a></li>
            </ul>
          </li>
        </ul>
      </li>
      <li><a href="#">About</a></li>
      <li><a href="#">Contact</a></li>
    </ul>
  </nav>

    </>
  );
}
export default MobileHeader;